module.exports = __webpack_public_path__ + "img/kim-pro.23e7f8b7.jpg";